import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse, BasicApiResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";
import { License } from "@dashboard/devices/types";

import { Provisioning } from "../types";

export const fetchProvisionings = async (payload: { workspaceId: number; isTerminated?: boolean }) => {
    if (payload.isTerminated) {
        return [];
    }
    try {
        const endpoint = await RouteService.getProvisioningsRoute();
        const { data } = await HttpService.get<ApiResponse<Provisioning[]>>(endpoint + `workspace/${payload.workspaceId}`);

        return data.model;
    } catch (error) {
        throw unpackError(error);
    }
};

export const updateProvisioning = async (payload: Provisioning) => {
    try {
        const endpoint = await RouteService.getProvisioningsRoute();
        const { data } = await HttpService.put<Provisioning, AxiosResponse<ApiResponse<Provisioning>>>(endpoint, payload);
        return data.model;
    } catch (error) {
        throw unpackError(error);
    }
};

export const createProvisioning = async (payload: Omit<Provisioning, "id">) => {
    try {
        const endpoint = await RouteService.getProvisioningsRoute();
        const { data } = await HttpService.post<Omit<Provisioning, "id">, AxiosResponse<ApiResponse<Provisioning>>>(
            endpoint,
            payload,
        );

        return data.model;
    } catch (error) {
        throw unpackError(error);
    }
};

export const deleteProvisioning = async (provisioningId: number) => {
    try {
        const endpoint = await RouteService.getProvisioningsRoute();
        await HttpService.delete<Provisioning, BasicApiResponse>(endpoint + String(provisioningId));
        return provisioningId;
    } catch (error) {
        throw unpackError(error);
    }
};
interface UpdateUniversalLicenseGroupPayload {
    id: number;
    groupId?: number | null;
}
export const updateUniversalLicenseGroup = async (payload: UpdateUniversalLicenseGroupPayload) => {
    try {
        const endpoint = await RouteService.getLicensesRoute();
        const formData = new FormData();

        if (payload.groupId !== undefined && payload.groupId !== null) {
            formData.append("groupId", payload.groupId.toString());
        }

        const { data } = await HttpService.patch<FormData, AxiosResponse<ApiResponse<License>>>(
            `${endpoint}${payload.id}/universalgroup`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
        );

        return data;
    } catch (error) {
        throw unpackError(error);
    }
};
export const deleteUniversalLicenseGroup = async (id: number): Promise<ApiResponse<License>> => {
    try {
        const formData = new FormData();
        formData.append("groupId", "null");

        const endpoint = await RouteService.getLicensesRoute();
        const { data } = await HttpService.patch<FormData, AxiosResponse<ApiResponse<License>>>(
            endpoint + `${id}/universalgroup`,
            formData,
        );

        return data;
    } catch (error) {
        throw unpackError(error);
    }
};
